import React, { useState, useEffect } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import { showSwal } from '../../../constants/swalConfig';
import BreadCrumbs from '../../../layouts/breadcrumbs/BreadCrumbs';
import ComponentCard from '../../../components/ComponentCard';
import ActionButton from '../../../components/common/ActionButton';
import AppSpinner from '../../../components/common/AppSpinner';
import StatusBadge from '../../../components/common/StatusBadge';
import DataTable from '../../../components/common/DataTable';
import api from '../../../constants/api';

const STATUS = {
  0: { label: 'Pending', variant: 'danger' },
  1: { label: 'Responded', variant: 'success' },
};

const ContactEnquiry = () => {
  const [activeTab, setActiveTab] = useState('1');
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  const allEnquiries = Array.isArray(enquiries) ? enquiries : [];
  const pendingEnquiries = allEnquiries.filter((res) => res.wc_status === '0');
  const respondedEnquiries = allEnquiries.filter((res) => res.wc_status === '1');

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const getAllEnquiries = () => {
    setLoading(true);
    api
      .get('/combined/enquiries/contact')
      .then((res) => {
        setEnquiries(res.data.data || []);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  };

  const updateEnquiry = (id) => {
  showSwal({
  title: 'Are you sure?',
  text: '',
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Confirm',
}).then((result) => {
  if (result.isConfirmed) {
    api
      .put(`/website/updateContact/${id}`)
      .then(() => {
        showSwal({
          title: 'Success!',
          text: '.',
          icon: 'success',
        });
        window.location.reload();
      })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const deleteRecord = (table, column, value) => {
   showSwal({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, delete it!',
}, 'delete').then((result) => {
  if (result.isConfirmed) {
    api
          .post('/service/deleteRecord', { table, column, value })
          .then(() => {
            showSwal({
              title: 'Deleted!',
              text: 'Your file has been deleted.',
              icon: 'success',
            });
            window.location.reload();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  useEffect(() => {
    getAllEnquiries();
  }, []);

  const columns = [
    { key: 'sno', header: 'S.No', render: (row, i) => i + 1 },
    { key: 'wc_name', header: 'Name', sortable: true },
    { key: 'wc_phone', header: 'Phone' },
    { key: 'wc_email', header: 'Email' },
    { key: 'wc_subject', header: 'Subject' },
    { key: 'wc_message', header: 'Message' },
    { key: 'wc_date_time', header: 'Date Time', sortable: true },
    {
      key: 'wc_status',
      header: 'Status',
      render: (row) => {
        const status = STATUS[row.wc_status];
        return status ? <StatusBadge variant={status.variant} label={status.label} /> : null;
      },
    },
    {
      key: 'action',
      header: 'Action',
      render: (row) => (
        <div className="d-flex gap-2">
          <ActionButton
            action="edit"
            onClick={() => {
              updateEnquiry(row.wc_id);
            }}
          />
          <ActionButton
            action="delete"
            onClick={() => {
              deleteRecord('website_contact', 'wc_id', row.wc_id);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <BreadCrumbs />
      <ComponentCard>
        <Nav tabs>
          <NavItem>
            <NavLink
              style={{ cursor: 'pointer' }}
              className={activeTab === '1' ? 'active' : ''}
              onClick={() => {
                toggle('1');
              }}
            >
              Pending
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: 'pointer' }}
              className={activeTab === '2' ? 'active' : ''}
              onClick={() => {
                toggle('2');
              }}
            >
              Responded
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent className="p-0" activeTab={activeTab}>
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                {loading ? (
                  <div className="d-flex justify-content-center py-4">
                    <AppSpinner size="inline" label="Loading..." />
                  </div>
                ) : (
                  <DataTable
                    columns={columns}
                    mode="client"
                    data={pendingEnquiries}
                    pageSize={15}
                    rowKey={(row) => row.wc_id}
                    searchPlaceholder="Search enquiries..."
                    emptyMessage="No pending enquiries found"
                  />
                )}
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row>
              <Col sm="12">
                {loading ? (
                  <div className="d-flex justify-content-center py-4">
                    <AppSpinner size="inline" label="Loading..." />
                  </div>
                ) : (
                  <DataTable
                    columns={columns}
                    mode="client"
                    data={respondedEnquiries}
                    pageSize={15}
                    rowKey={(row) => row.wc_id}
                    searchPlaceholder="Search enquiries..."
                    emptyMessage="No responded enquiries found"
                  />
                )}
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </ComponentCard>
    </>
  );
};

export default ContactEnquiry;
